export default class Terms
{
  static update(user, terms)
  {
    return user.value == terms.value;
  }
 static publish(user, terms)
  {
    // admin
    if (user.role === 'admin') {
      return true;
    }

    // moderator
    if (user.role === 'moderator' && user.category.id === post.category.id) {
      return true;
    }

    return true;
  }
  
}
